import { render, staticRenderFns } from "./IconSvgSnmmiNotifications.vue?vue&type=template&id=5ef2d098&scoped=true&"
import script from "./IconSvgSnmmiNotifications.vue?vue&type=script&lang=js&"
export * from "./IconSvgSnmmiNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2d098",
  null
  
)

export default component.exports